//import { register } from 'service-worker.js';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { UserProvider } from './UserContext';
//import { PropertyProvider } from './contexts/context-property';
import { EssayProvider } from './contexts/context-essay';
import AppTourProvider from './contexts/context-tour';
import { ExerciseProvider } from './contexts/context-exercise';
import { UserProviderNew } from './contexts/context-user';
import { LocalizationProvider } from '@mui/x-date-pickers';
//import { GoogleOAuthProvider } from '@react-oauth/google';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';

import './index.css';
import App from './App';
import Offline from './Offline';

//import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import Login from './components/login';
import PageFeedback from './components/feedback';
import PageEssaySharePrint from './components/essay-share-print';
import PageEssayReportPrint from './components/report-card/report-card';
import PageQuestion from './components/question';
import PageHome from './components/home';
import PageHomeEssay from './components/home-essay';
import PageHomeExercise from './components/home-exercise';
import PageProfile from './components/profile';
import EssayScoreRules from './components/essay/essay-score-rules';
import PageExercise from './components/exercise';
import PageEssayShare from './components/essay-share';
import reportWebVitals from './reportWebVitals';
import PageSaEssayLists from './components/sa-essay-lists';
import PageSaExerciseLists from './components/sa-exercise-lists';
import PageSaEssayListV2 from './components/sa-essay-list-v2';
import PageEssayDetail from './components/sa-essay-detail';
import PageExerciseDetail from './components/sa-exercise-detail';
import PageSaUserLogList from './components/sa-user-log-list';
import PageSaFeedbackList from './components/sa-feedback-list';
import PageSaQuestionList from './components/question-list-v2';
import PageQuestionSetList from './components/sentence-transformation/question-set-list';
import PageSaEssaySubmit from './components/sa-essay-submit';
import PageTutorInvite from './components/tutor-invite';
import PageStudentParent from './components/student-parent';
import ReportCard from './components/report-card/report-card';
import ReportCardExercise from './components/report-card/report-card-exercise';

import Dev01 from './components/dev/dev-01';
import Dev02 from './components/dev/dev-02';

const theme = createTheme({
  typography: {
    fontFamily: "Inter, sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 700, 
        },
      },
    },

    MuiChip: {
      styleOverrides: {
        label: {
          fontWeight: 700, 
        },
      },
    },
  },


});

const isOffline = false;
ReactDOM.createRoot(document.getElementById('root')).render(
  <Router>
    {/* <GoogleOAuthProvider clientId="114727211497-4vonbveq8tdskfr3sdcsuhdm10qpebos.apps.googleusercontent.com"
      redirect_uri="https://accounts.google.com/o/oauth2/v2/auth?client_id=114727211497-4vonbveq8tdskfr3sdcsuhdm10qpebos.apps.googleusercontent.com&redirect_uri=http://localhost:3000&response_type=code&scope=email%20profile%20https://www.googleapis.com/auth/calendar.calendars.readonly%20https://www.googleapis.com/auth/calendar.events.owned&access_type=offline"
    > */}
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
      <UserProvider>
        <UserProviderNew>
          <EssayProvider>
          <ExerciseProvider>
            <AppTourProvider>
            <Routes>
              <Route path="/" element={isOffline ? <Offline /> : <App />} />
              <Route path="/feedback" element={isOffline ? <Offline /> : <PageFeedback />} />
              <Route path="/home" element={isOffline ? <Offline /> : <PageHome />} />
              <Route path="/home-essay" element={isOffline ? <Offline /> : <PageHomeEssay />} />			  
              <Route path="/home-exercise" element={isOffline ? <Offline /> : <PageHomeExercise />} />
              <Route path="/login" element={isOffline ? <Offline /> : < App />} />
              <Route path="/login/invite/:inviteId" element={isOffline ? <Offline /> : < App />} />
              <Route path="/profile" element={isOffline ? <Offline /> : <PageProfile />} />
              <Route path="/report" element={isOffline ? <Offline /> : <ReportCard />} />
              <Route path="/report-exercise" element={isOffline ? <Offline /> : <ReportCardExercise />} />
              <Route path="/essay/score/rule" element={isOffline ? <Offline /> : <EssayScoreRules />} />
              <Route path="/exercise" element={isOffline ? <Offline /> : <PageExercise />} />
              <Route path="/sa" element={isOffline ? <Offline /> : <PageSaEssayListV2 />} />
			  <Route path="/sa/essay" element={isOffline ? <Offline /> : <PageSaEssayLists />} />
			  <Route path="/sa/exercise" element={isOffline ? <Offline /> : <PageSaExerciseLists />} />
			  <Route path="/tutor" element={isOffline ? <Offline /> : <PageTutorInvite />} />
			  <Route path="/student" element={isOffline ? <Offline /> : <PageStudentParent />} />
			  //<Route path="/saV2" element={isOffline ? <Offline /> : <PageSaEssayListV2 />} />
			  //<Route path="/saV2/essay" element={isOffline ? <Offline /> : <PageSaEssayLists />} />
              <Route path="/essay/detail/:pageEssayId" element={isOffline ? <Offline /> : <PageEssayDetail />} />
              <Route path="/exercise/detail/:exerciseId" element={isOffline ? <Offline /> : <PageExerciseDetail />} />
              <Route path="/essay/share/:shareId" element={isOffline ? <Offline /> : <PageEssayShare />} />
			        <Route path="/essay/share/print/:shareId" element={isOffline ? <Offline /> : <PageEssaySharePrint />} />
              <Route path="/essay/share/print/:shareId/:userToken" element={isOffline ? <Offline /> : <PageEssaySharePrint />} />
			        <Route path="/report/print/:profileId/:userToken" element={isOffline ? <Offline /> : <PageEssayReportPrint printMode={true}/>} />
              <Route path="/sa/userLogs" element={isOffline ? <Offline /> : <PageSaUserLogList />} />
              <Route path="/sa/feedbacks" element={isOffline ? <Offline /> : <PageSaFeedbackList />} />
			  <Route path="/question" element={isOffline ? <Offline /> : <PageSaQuestionList />} />
			  <Route path="/question-set" element={isOffline ? <Offline /> : <PageQuestionSetList />} />
			  <Route path="/sa/essay/submit" element={isOffline ? <Offline /> : <PageSaEssaySubmit />} />
              <Route path="/dev/01" element={isOffline ? <Offline /> : <Dev01 />} />
              <Route path="/dev/02" element={isOffline ? <Offline /> : <Dev02 />} />
            </Routes>
            </AppTourProvider>
          </ExerciseProvider>
          </EssayProvider>
        </UserProviderNew>
      </UserProvider>
      </ThemeProvider>
    </LocalizationProvider>
    {/* </GoogleOAuthProvider> */}
  </Router>
);

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// serviceWorkerRegistration.register({
//   enabled: //environment.production && 
//     (navigator['standalone'] || window.matchMedia('(display-mode: standalone)').matches),
// });
reportWebVitals();
